import { createAction, props } from '@ngrx/store';
import { IIssueData, IIssueModel } from '@partners/api';

export class IssueActions {
  static reset = createAction('[Issue] Reset State');
  static load = createAction('[Issue] Load');
  static loadSuccess = createAction('[Issue] Load Success', props<{ model: IIssueModel; data: IIssueData }>());
  static loadFailure = createAction('[Issue] Load Failure', props<{ error: any }>());
  static submit = createAction('[Issue] Submit');
  static submitSuccess = createAction('[Issue] Submit Success', props<{ model: IIssueModel; data: IIssueData }>());
  static submitFailure = createAction('[Issue] Submit Failure', props<{ error: any }>());
  static saveScreenName = createAction('[Issue] Save ScreenName', props<{ screenName: string }>());
}
